module.exports = __webpack_public_path__ + "static/media/G1-9-Nyssa-Kontos-cod29.37709040.png";